import axios from 'axios';
import { API_BASE_URL as TIME_SERIES_API_BASE_URL } from './apiConfig';

const timeSeriesApi = axios.create({
  baseURL: TIME_SERIES_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Time Series API endpoints
export const getAvailableMinerals = async () => {
  try {
    const response = await timeSeriesApi.get('/api/time-series/minerals');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch available minerals');
  }
};

export const getAvailableFlows = async () => {
  try {
    const response = await timeSeriesApi.get('/api/time-series/flows');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch available flows');
  }
};

export const getMonthlyData = async (mineral, flow) => {
  try {
    const response = await timeSeriesApi.get('/api/time-series/monthly-data', {
      params: { mineral, flow }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch monthly data');
  }
};

export const getTimeSeriesData = async (mineral, flow) => {
  try {
    const response = await timeSeriesApi.get('/api/time-series/data', {
      params: { mineral, flow }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch time series data');
  }
};

// Enhanced comprehensive time series data endpoint
export const getComprehensiveTimeSeriesData = async (mineral, flow) => {
  try {
    console.log(`[timeSeriesApi] Fetching comprehensive data for mineral=${mineral}, flow=${flow}`);
    const response = await timeSeriesApi.get('/api/time-series/comprehensive-data', {
      params: { mineral, flow }
    });
    console.log(`[timeSeriesApi] Successfully fetched comprehensive data:`, response.data);
    return response.data;
  } catch (error) {
    console.error('[timeSeriesApi] Error fetching comprehensive time series data:', error);
    console.error('[timeSeriesApi] Error response:', error.response);
    console.error('[timeSeriesApi] Error message:', error.message);
    const errorMessage = error.response?.data?.detail || error.response?.data?.message || error.message || 'Failed to fetch comprehensive time series data';
    throw new Error(errorMessage);
  }
};

// Get 3-year summary data
export const getThreeYearSummary = async (mineral, flow) => {
  try {
    const response = await timeSeriesApi.get('/api/time-series/three-year-summary', {
      params: { mineral, flow }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch 3-year summary data');
  }
};

// Get 5-year summary data
export const getFiveYearSummary = async (mineral, flow) => {
  try {
    const response = await timeSeriesApi.get('/api/time-series/five-year-summary', {
      params: { mineral, flow }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch 5-year summary data');
  }
};

// Get growth analysis data
export const getGrowthAnalysis = async (mineral, flow) => {
  try {
    const response = await timeSeriesApi.get('/api/time-series/growth-analysis', {
      params: { mineral, flow }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch growth analysis data');
  }
};

// Get moving averages data
export const getMovingAverages = async (mineral, flow) => {
  try {
    const response = await timeSeriesApi.get('/api/time-series/moving-averages', {
      params: { mineral, flow }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch moving averages data');
  }
};

// Get year-over-year growth data
export const getYearOverYearGrowth = async (mineral, flow) => {
  try {
    const response = await timeSeriesApi.get('/api/time-series/year-over-year-growth', {
      params: { mineral, flow }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch year-over-year growth data');
  }
};

export default timeSeriesApi;
